export default "__VITE_ASSET__1d60ba70__"